export default {
  id: 'imagine.pairing.Close',
  type: 'imagine.pairing.Close',
  perform: opts => {
    const {
      context
    } = opts;
    context?.onClose?.();
  }
};